export const Link = "https://asokorerbapis.cbxapps.com";
// export const Link = "http://localhost:5000";
